import $ from 'jquery';
import { dispatchAction } from 'linksoft';
import { refreshData } from './actions';

const refresh = () => {
    $(document).off('siisel.chainageUpdated', handleChangesSaved);
    $(document).on('siisel.chainageUpdated', handleChangesSaved);
}

const handleChangesSaved = (data) => {
    dispatchAction(refreshData());
};

export default refresh;


// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/refresh.js